import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { type CloudMarketplace } from '../../types/marketplace'

type UseCurrentCloudProviderRootState = {
  productListingFilters: {
    cloudMarketplace: CloudMarketplace
  }
}

export const useCurrentCloudProvider = (): CloudMarketplace => {
  const { cloud: cloudFromParams, cloudType: cloudTypeFromParams } = useParams<{
    cloud?: string
    cloudType?: string
  }>()
  const currentCloudProvider = useSelector(
    (state: UseCurrentCloudProviderRootState) =>
      state.productListingFilters.cloudMarketplace
  )
  const receivedResale = window.location.pathname?.includes(
    'reseller-authorizations/received'
  )

  if (receivedResale) return 'AWS'

  const cloudFromRoute = cloudFromParams || cloudTypeFromParams
  if (cloudFromRoute) {
    return cloudFromRoute.toUpperCase() as CloudMarketplace
  }

  return currentCloudProvider
}
